import Symbol           from 'es6-symbol/polyfill';
import EventEmitter     from 'events';
import UsersService     from '@/services/Users';
import OrdersService     from '@/services/Orders';

let singleton = Symbol();
let singletonEnforcer = Symbol();

class AppControlService extends EventEmitter {

  //________________________________________________________ constructor
  // -
  constructor(pEnforcer) {
    if (pEnforcer !== singletonEnforcer) {
      throw 'Cannot construct singleton';
    }
    super();
    this._currentStep = 0;
    this._isOpen = false;
    this._isOpenGrouped = false;
    this._isAuthByStep = false;

    this.on('validating', (step) => {
      if(step === 0 || step === 2) this.goToNextStep();
    })
  }

  static getInstance() {
    if (!this[singleton]) {
      this[singleton] = new AppControlService(singletonEnforcer);
    }
    return this[singleton];
  }

  get currentStep() {
    return this._currentStep;
  }

  get isOpenGrouped() {
    return this._isOpenGrouped;
  }

  get isOpen() {
    return this._isOpen;
  }

  get isAuthByStep() {
    return this._isAuthByStep;
  }

  abortStep() {
    this.emit('aborted', this._currentStep);
  }

  validStep() {
    this.emit('validating', this._currentStep);
  }

  goTo(step) {
    this._currentStep = this._stepControl( step );
    this.emit('step', this._currentStep);
  }

  goToNextStep() {
    this._currentStep = this._stepControl( this._currentStep + 1);
    this.emit('step', this._currentStep);
  }

  _stepControl(step) {
    if( !UsersService.isConnected && step !== 0) {
      this._isAuthByStep = true;
      window.openLogin();
      document.body.addEventListener('logged', () => {
        UsersService.me().then(() => {
          OrdersService.get().then(() => {
            this.goTo(step);
          })
        })
      }, {once: true});
      return 0;
    }
    if (step >= 0 && OrdersService.cart.items.length === 0 && OrdersService.cart.processingType && OrdersService.cart.processingType.enabled ) return 0;
    if (step >= 1 && !UsersService.isValid && OrdersService.cart.billingAddress && OrdersService.cart.shippingAddress ) return 1;
    // No shipping method (e.g. no eligible method for the cart): stay on the delivery step
    if (step > 2 && !OrdersService.cart.shippingMethod) return 2;
    return step;
  }

  openGroupedCard() {
    this._isOpenGrouped = true;
    document.body.classList.add('is-opening-cart');
    setTimeout(() => {
      document.body.classList.remove('is-opening-cart');
      document.body.classList.add('is-open-cart');
    }, 500);
    this.emit('open-grouped-to-card', {
      open: this._isOpenGrouped
    });
  }

  closeGroupedCard() {
    this._isOpenGrouped = false;
    document.body.classList.remove('is-open-cart');
    document.body.classList.add('is-opening-cart');
    setTimeout(() => {
      document.body.classList.remove('is-opening-cart');
      this.emit('open-grouped-to-card', {
        open: this._isOpenGrouped
      });
    }, 200);
  }

  openAddCard(item = null, dupplicate = false) {
    this._isOpen = true;
    document.body.classList.add('is-opening-cart');
    setTimeout(() => {
      document.body.classList.remove('is-opening-cart');
      document.body.classList.add('is-open-cart');
    }, 500);
    this.emit('open-add-to-card', {
      item,
      dupplicate,
      open: this._isOpen
    });
  }

  closeAddCard() {
    this._isOpen = false;
    document.body.classList.remove('is-open-cart');
    document.body.classList.add('is-opening-cart');
    setTimeout(() => {
      document.body.classList.remove('is-opening-cart');
      this.emit('open-add-to-card', {
        open: this._isOpen
      });
    }, 200);
  }

}
export default AppControlService.getInstance();